import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import React from "react";
import { Bar, BarChart, Cell, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { green } from "../../../../theme/colors";
var data = [{
        name: "Viewed",
        percentage: 50,
        count: 50
    }, {
        name: "Clicked",
        percentage: 40,
        count: 40
    }, {
        name: "Booked",
        percentage: 15,
        count: 15
    }, {
        name: "Bounce off",
        percentage: 34,
        count: 33
    }];
export default function ServiceRemindersBarChart() {
    var _a = React.useState("Whatsapp"), channel = _a[0], setChannel = _a[1];
    var handleChannelChange = function (event) {
        setChannel(event.target.value);
    };
    var total = data.reduce(function (acc, it) { return acc + it.count; }, 0);
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: 2,
            maxWidth: 700,
            margin: "auto",
            border: "1px solid #e0e0e0",
            borderRadius: "10px",
            backgroundColor: "#fff"
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "strong"
    }, "Service reminders")), /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "secondary"
    }, "Total Reminders"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 24,
        fontWeight: "strong"
    }, total)), /*#__PURE__*/ React.createElement(Select, {
        value: channel,
        onChange: handleChannelChange,
        size: "small",
        IconComponent: KeyboardArrowDownRounded
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: "Whatsapp"
    }, "Whatsapp"), /*#__PURE__*/ React.createElement(MenuItem, {
        value: "Email"
    }, "Email"), /*#__PURE__*/ React.createElement(MenuItem, {
        value: "SMS"
    }, "SMS"))), /*#__PURE__*/ React.createElement(ResponsiveContainer, {
        width: "100%",
        height: 300
    }, /*#__PURE__*/ React.createElement(BarChart, {
        data: data
    }, /*#__PURE__*/ React.createElement(XAxis, {
        dataKey: "name",
        height: 30,
        fontSize: 12,
        tickLine: false
    }), /*#__PURE__*/ React.createElement(YAxis, {
        domain: [0, 60],
        tickCount: 5,
        width: 30,
        fontSize: 12
    }), /*#__PURE__*/ React.createElement(Bar, {
        dataKey: "count",
        fill: green[600],
        barSize: "20%",
        background: {
            fill: green[50]
        },
        label: {
            position: 'top'
        }
    }, data.map(function (entry, index) { /*#__PURE__*/ return React.createElement(Cell, {
        key: "cell-".concat(index)
    }); })))));
}
